import Cookies from "js-cookie";

/** The cookie holding the web build this browser last ran. */
export const APP_VERSION_COOKIE = "app_version";
/** How long the stamp lasts, in days, js-cookie's unit. */
const APP_VERSION_COOKIE_DAYS = 365;

/**
 * Reload onto a new build after a deploy. Each deploy writes a new
 * VITE_VERSION into env-config.js when the web container starts
 * (docker/start.sh); a browser that last ran another version reloads, so
 * the router never mounts with chunk names the deploy replaced. A first
 * visit only stamps the version: it already has the latest bundle, and a
 * reload then raced lazy route loading into a flash of the error boundary.
 *
 * It touches no other cookie (#230 "Look into our cookie uses", Tyler,
 * 2026-09-29). It used to delete every cookie the page could see, from its
 * first commit (2024-11-29, message ".."), when this was the only cookie the
 * web app had; every cookie of ours since is HttpOnly and out of its reach, so
 * the sweep only ever took Stripe's fraud cookies and the load balancer's.
 */
export const reloadOnNewVersion = (currentVersion, reload) => {
  const storedVersion = Cookies.get(APP_VERSION_COOKIE);
  if (storedVersion && storedVersion !== currentVersion) {
    Cookies.set(APP_VERSION_COOKIE, currentVersion, { expires: APP_VERSION_COOKIE_DAYS });
    reload();
  } else if (!storedVersion) {
    Cookies.set(APP_VERSION_COOKIE, currentVersion, { expires: APP_VERSION_COOKIE_DAYS });
  }
};
